import React, { useState, useEffect } from "react";
import {
  Table,
  Container,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Placeholder from "../../../assets/images/Placeholder.gif";
import "react-datepicker/dist/react-datepicker.css";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import check from "../../../assets/images/check.svg";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";

const GymPayout = () => {
  document.title = " Transaction History | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const [timeFilter, setTimeFilter] = useState("week");
  const [dropdownOpen, setDropdownOpen] = useState({ dateRange: false });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startSearchDate, setStartSearchDate] = useState();
  const [endSearchDate, setEndSearchDate] = useState();
  const [data, setData] = useState([]);
  const [stats, setStats] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [seletedGymId, setSeletedGymId] = useState("");
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);

  const gymIds = async () => {
    try {
      let endpoint;
      if (currentUser.appRole === "admin") {
        endpoint = `${endpoints.gym}/admin?limit=50`;
      } else if (currentUser.appRole === "gymOwner") {
        endpoint = `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`;
      } else {
        console.error("User role is not admin or gymOwner.");
        return;
      }

      const resp = await get(endpoint);

      if (resp?.data?.success) {
        const gymList = resp.data.data || [];
        setGymData(gymList);

        if (gymList.length > 0) {
          setSelectedGym(gymList[0]?.name || "Unknown Gym");
          setSeletedGymId(gymList[0]?._id || null);
        } else {
        }
      } else {
        console.error(
          "Failed to fetch gyms:",
          resp?.data?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error in fetching gyms:", error);
    }
  };

  useEffect(() => {
    if (
      currentUser.appRole == "gymOwner" ||
      currentUser.appRole == "gymStaff" ||
      currentUser.appRole == "admin"
    ) {
      gymIds();
    }
  }, []);
  useEffect(() => {
    if (seletedGymId) {
      fetchData();
    }
  }, [seletedGymId]);

  const toggleDropdown = (key) => {
    setDropdownOpen((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    setStartSearchDate(null);
    setEndSearchDate(null);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(
        `${endpoints.transaction}/gym/${seletedGymId}`
      );
      if (response && response.data) {
        setData(response.data.data || []);
        setTotalAmount(response.data.totalAmount || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  const updateDescription = (description) => {
    return description.replace(/(\$\d+(\.\d+)?) has/, (match, amount) => {
      const numericValue = parseFloat(amount.replace("$", ""));
      const updatedValue = (numericValue * 0.9).toFixed(2);
      return `$${formatNumber(parseFloat(updatedValue))} has`;
    });
  };
  return (
    <div className="">
      <Container fluid>
        <Card className="rounded-4">
          <CardBody>
            <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              {/* Title Section */}
              <div className="d-flex flex-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 w-75">
                  Transaction History
                </span>
              </div>

              {/* Dropdown Section */}
              <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-md-0">
                <div className="d-flex flex-xs-row gap-2 w-100 w-sm-auto">
                  {/* Gym Dropdown */}
                  <Dropdown
                    isOpen={dropdownOpen.selectGym}
                    toggle={() => toggleDropdown("selectGym")}
                    className="w-100 w-sm-auto"
                  >
                    <DropdownToggle
                      caret
                      className="filter-btn d-flex justify-content-between align-items-center  w-100 w-xs-auto"
                    >
                      <span className=" w-100 w-xs-auto">
                        {selectedGym}
                        <small style={{ fontSize: "9px" }}>
                          (Selected GYM)
                        </small>
                      </span>
                      <img src={check} alt="Location" className="ms-2" />
                    </DropdownToggle>
                    <DropdownMenu
                      style={{ zIndex: 1, maxHeight: "200px", width: "200px" }}
                    >
                      <SimpleBar style={{ maxHeight: "185px", width: "100%" }}>
                        {gymData.map((item, index) => (
                          <DropdownItem
                            key={index}
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setSelectedGym(item.name);
                              setSeletedGymId(item._id);
                            }}
                          >
                            {item.name}
                          </DropdownItem>
                        ))}
                      </SimpleBar>
                    </DropdownMenu>
                  </Dropdown>

                  {/* Date Range Dropdown (Commented Out) */}
                  {/* <Dropdown
        className="w-100 w-sm-auto"
        isOpen={dropdownOpen.dateRange}
        toggle={() => toggleDropdown("dateRange")}
      >
        <DropdownToggle
          caret
          className="filter-btn d-flex ff-sora justify-content-between align-items-center w-100"
        >
          <span className="fw-normal ff-sora secondary-black font-size-14">
            Date Range
          </span>
          <img src={caldropdown} alt="Calendar Dropdown" className="ms-2" />
        </DropdownToggle>

        <DropdownMenu style={{ zIndex: 2 }} className="p-3">
          <div className="d-flex flex-column">
            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
              Start Date
            </span>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
                let temp = formatDate(date);
                setStartSearchDate(temp);
              }}
              dateFormat="yyyy/MM/dd"
              className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
              placeholderText="Select Start Date"
            />
            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
              End Date
            </span>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
                let temp = formatDate(date);
                setEndSearchDate(temp);
              }}
              dateFormat="yyyy/MM/dd"
              className="form-control fw-normal ff-sora secondary-black font-size-14"
              placeholderText="Select End Date"
            />
          </div>
          <button
            type="button"
            onClick={handleClearDates}
            className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
          >
            Clear
          </button>
        </DropdownMenu>
      </Dropdown> */}
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <div
                className="hide-scrollbar table-responsive rounded-4"
                style={{
                  height: data?.length > 0 ? "500px" : "auto",
                }}
              >
                <Table hover>
                  <thead className="table-bordered">
                    <tr className="ff-sora font-size-14 fw-bold primary-black">
                      <th>No</th>
                      <th>Transaction Type</th>
                      <th>Credit Amount</th>
                      <th>Balance Before</th>
                      <th>Balance After</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={8} className="text-center">
                          <div className="d-flex justify-content-center align-items-center">
                            <div
                              className="spinner-border"
                              style={{
                                width: "3rem",
                                height: "3rem",
                                color: "#3BABA6",
                              }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <></>
                    ) : (
                      data?.map((item, index) => {
                        const amount = item.amount?.$numberDecimal || "0.00";
                        const balanceBefore =
                          item.balanceBefore?.$numberDecimal || "0.00";
                        const balanceAfter =
                          item.balanceAfter?.$numberDecimal || "0.00";
                        const transactionStatus =
                          item.TransactionStatus || "N/A";
                        const createdAt = item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString()
                          : "N/A";
                        const description = item.description || "N/A";

                        return (
                          <tr
                            className="ff-sora fw-normal font-size-14 secondary-black"
                            key={item._id + index}
                          >
                            <td>{index + 1}</td>
                            <td className="text-capitalize">
                              {item.transactionType}
                            </td>
                            <td className="text-capitalize">
                              ${formatNumber(parseFloat(amount * 0.9))}
                            </td>
                            <td className="text-capitalize">
                              ${formatNumber(parseFloat(balanceBefore))}
                            </td>
                            <td className="text-capitalize">
                              ${formatNumber(parseFloat(balanceAfter))}
                            </td>
                            <td className="text-capitalize">
                              {transactionStatus}
                            </td>
                            <td className="text-capitalize">{createdAt}</td>
                            <td>{updateDescription(description)}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
                {!loading && data?.length === 0 && (
                  <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                    <img
                      src={Placeholder}
                      alt="No record placeholder"
                      className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                    />
                    <p className="mt-3 ff-sora font-size-16 fw-normal">
                      No Record Found!
                    </p>
                  </div>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>{" "}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </div>
  );
};

export default GymPayout;
